module.exports = __webpack_public_path__ + "img/s.a11b2ae5.jpg";